import { Component, OnInit } from '@angular/core';
import { AlertWrapperService,AlertState } from '../../services/alert-wrapper.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-alert-wrapper',
  templateUrl: './alert-wrapper.component.html',
  styleUrls: ['./alert-wrapper.component.scss']
})
export class AlertWrapperComponent implements OnInit {
  constructor(private _alert:AlertWrapperService){}
  isOpen: Observable<AlertState> | null = null;

  ngOnInit(): void {
    this.isOpen = this._alert.isOpen;

  }
    onClose() {
        this._alert?.close();
    }
}
